module.exports = __webpack_public_path__ + "static/media/healthy-environment.dec15948.svg";